export const environment = {
  production: false,
  environmentName: 'mfp',
  dirPrefix: 'mfp'
};
